import { render, staticRenderFns } from "./programOccurrence.vue?vue&type=template&id=63c80396&"
import script from "./programOccurrence.vue?vue&type=script&lang=js&"
export * from "./programOccurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports